import React, { createContext, useContext, useState, useEffect } from 'react';

var colors = {
  dark: {
    bg: '#0B0D11', bgCard: 'rgba(255,255,255,0.03)', bgCardHover: 'rgba(255,255,255,0.05)',
    borderCard: 'rgba(255,255,255,0.06)', text: '#fff', textMuted: 'rgba(255,255,255,0.65)',
    textFaint: 'rgba(255,255,255,0.35)', textGhost: 'rgba(255,255,255,0.2)',
    accent: '#818CF8', green: '#4ADE80', red: '#EF4444', amber: '#E8A838', blue: '#38BDF8', pink: '#F472B6',
  },
  light: {
    bg: '#F8F9FC', bgCard: '#FFFFFF', bgCardHover: '#F3F4F9',
    borderCard: 'rgba(0,0,0,0.08)', text: '#1A1D26', textMuted: 'rgba(0,0,0,0.6)',
    textFaint: 'rgba(0,0,0,0.35)', textGhost: 'rgba(0,0,0,0.18)',
    accent: '#6366F1', green: '#16A34A', red: '#DC2626', amber: '#D97706', blue: '#2563EB', pink: '#DB2777',
  }
};

var ThemeContext = createContext();

export function ThemeProvider({ children }) {
  var s = useState(function() { try { return localStorage.getItem('supra-theme') || 'dark'; } catch(e) { return 'dark'; } });
  var mode = s[0]; var setMode = s[1];
  var toggle = function() { var n = mode === 'dark' ? 'light' : 'dark'; setMode(n); try { localStorage.setItem('supra-theme', n); } catch(e) {} };
  return React.createElement(ThemeContext.Provider, { value: { mode: mode, c: colors[mode], toggle: toggle } }, children);
}

export function useTheme() { return useContext(ThemeContext); }

export function ThemeToggle() {
  var t = useTheme();
  return React.createElement('button', {
    onClick: t.toggle,
    style: { background: 'none', border: '1px solid ' + t.c.borderCard, borderRadius: 6, padding: '6px 10px', cursor: 'pointer', fontSize: 14, color: t.c.textFaint }
  }, t.mode === 'dark' ? '\u2600' : '\u263D');
}
